export class WorkFormItem {
  public id?: number;
  public content?: string;
  public checked?: boolean;
  constructor() {
  }
}
